// components/Toast.jsx
import React, { useEffect } from "react";

export default function Toast({ message, type = "info", onClose, durationMs = 4200 }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => onClose?.(), durationMs);
    return () => clearTimeout(t);
  }, [message, onClose, durationMs]);

  if (!message) return null;

  const isErr = type === "error";
  const bg = isErr ? "rgba(239,68,68,0.92)" : "rgba(16,185,129,0.92)";
  const border = isErr ? "rgba(239,68,68,1)" : "rgba(16,185,129,1)";

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "fixed",
        top: 18,
        right: 18,
        zIndex: 4000,
        background: bg,
        color: "#fff",
        padding: "12px 14px",
        borderRadius: 12,
        border: `1px solid ${border}`,
        boxShadow: "0 18px 40px rgba(15,23,42,0.25)",
        minWidth: 260,
        maxWidth: 460,
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        backdropFilter: "blur(8px)",
      }}
    >
      <div style={{ flex: 1, lineHeight: 1.35, fontWeight: 650, fontSize: 13 }}>
        {message}
      </div>
      <button
        onClick={() => onClose?.()}
        className="btn-secondary"
        style={{
          padding: "6px 10px",
          borderRadius: 10,
          background: "rgba(255,255,255,0.14)",
          border: "1px solid rgba(255,255,255,0.25)",
          color: "#fff",
          fontWeight: 800,
        }}
        title="Close"
        aria-label="Close toast"
        type="button"
      >
        ✕
      </button>
    </div>
  );
}
